import React, { useEffect, useState } from "react";
import HomeContainer from "./HomeContainer";
import SettingsComponent from "../components/SettingsComponent";
import { useDispatch, useSelector } from "react-redux";
import { getSingleSignOn } from "../store/actions";

const SettingsContainer = () => {
  const dispatch = useDispatch();
  const [SSOData, setSSOData] = useState("");
  const fetchGetSignleSignOn = useSelector(
    (state) => state.fetchGetSignleSignOn
  );
  useEffect(() => {
    dispatch(getSingleSignOn());
  }, []);
  useEffect(() => {
    if (fetchGetSignleSignOn && fetchGetSignleSignOn.message) {
      setSSOData(fetchGetSignleSignOn.message);
    }
  }, [fetchGetSignleSignOn]);

  const content = <SettingsComponent data={SSOData} />;
  return <HomeContainer content={content} />;
};

export default SettingsContainer;
